export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	venusaurmega: {
		tier: "UUBL",
		doublesTier: "DUU",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	charizardmegax: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	charizardmegay: {
		tier: "OU",
		doublesTier: "DOU",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	blastoisemega: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	beedrillmega: {
		tier: "UU",
		doublesTier: "DUU",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pidgeotmega: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	rattata: {
		tier: "LC",
	},
	rattataalola: {
		tier: "LC",
	},
	raticate: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	raticatealola: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	raticatealolatotem: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pichu: {
		tier: "LC",
	},
	pikachu: {
		tier: "NFE",
	},
	pikachuoriginal: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pikachuhoenn: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pikachusinnoh: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pikachuunova: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pikachukalos: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pikachualola: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pikachupartner: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	raichu: {
		tier: "(PU)",
		doublesTier: "DUU",
	},
	raichualola: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	sandshrew: {
		tier: "LC",
	},
	sandshrewalola: {
		tier: "LC",
	},
	sandslash: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	sandslashalola: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		tier: "PU",
		doublesTier: "NFE",
	},
	clefable: {
		tier: "OU",
		doublesTier: "DUU",
	},
	vulpix: {
		tier: "NFE",
	},
	vulpixalola: {
		tier: "LC",
	},
	ninetales: {
		tier: "RU",
		doublesTier: "DUU",
	},
	ninetalesalola: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "NU",
		doublesTier: "NFE",
	},
	crobat: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		tier: "NUBL",
		doublesTier: "(DUU)",
	},
	bellossom: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	diglett: {
		tier: "LC",
	},
	diglettalola: {
		tier: "LC",
	},
	dugtrio: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	dugtrioalola: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	meowth: {
		tier: "LC",
	},
	meowthalola: {
		tier: "LC",
	},
	persian: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	persianalola: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		tier: "RU",
		doublesTier: "DUU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NFE",
	},
	poliwrath: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	politoed: {
		tier: "(PU)",
		doublesTier: "DOU",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "NFE",
	},
	alakazam: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	alakazammega: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "NFE",
	},
	machamp: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	tentacool: {
		tier: "LC",
	},
	tentacruel: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	geodude: {
		tier: "LC",
	},
	geodudealola: {
		tier: "LC",
	},
	graveler: {
		tier: "NFE",
	},
	graveleralola: {
		tier: "NFE",
	},
	golem: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	golemalola: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	ponyta: {
		tier: "LC",
	},
	rapidash: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	slowpoke: {
		tier: "LC",
	},
	slowbro: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	slowbromega: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	slowking: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "UU",
		doublesTier: "NFE",
	},
	magnezone: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	farfetchd: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	grimer: {
		tier: "LC",
	},
	grimeralola: {
		tier: "LC",
	},
	muk: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	mukalola: {
		tier: "UU",
		doublesTier: "DUU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	gastly: {
		tier: "LC",
	},
	haunter: {
		tier: "PU",
		doublesTier: "NFE",
	},
	gengar: {
		tier: "UU",
		doublesTier: "DUU",
	},
	gengarmega: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	onix: {
		tier: "LC",
	},
	steelix: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	steelixmega: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	voltorb: {
		tier: "LC",
	},
	electrode: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	exeggcute: {
		tier: "LC",
	},
	exeggutor: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	exeggutoralola: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	marowakalola: {
		tier: "RU",
		doublesTier: "DUU",
	},
	marowakalolatotem: {
		tier: "RU",
		doublesTier: "DUU",
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	hitmonchan: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	hitmontop: {
		tier: "NU",
		doublesTier: "DUU",
	},
	lickitung: {
		tier: "LC",
	},
	lickilicky: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		tier: "NU",
		doublesTier: "NFE",
	},
	rhyperior: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	happiny: {
		tier: "LC",
	},
	chansey: {
		tier: "OU",
		doublesTier: "NFE",
	},
	blissey: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	tangela: {
		tier: "PU",
		doublesTier: "NFE",
	},
	tangrowth: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	kangaskhan: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	kangaskhanmega: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NFE",
	},
	kingdra: {
		tier: "NUBL",
		doublesTier: "DOU",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		tier: "UU",
		doublesTier: "DUU",
	},
	mimejr: {
		tier: "LC",
	},
	mrmime: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	scyther: {
		tier: "PU",
		doublesTier: "NFE",
	},
	scizor: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	scizormega: {
		tier: "OU",
		doublesTier: "DUU",
	},
	smoochum: {
		tier: "LC",
	},
	jynx: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	elekid: {
		tier: "LC",
	},
	electabuzz: {
		tier: "NFE",
	},
	electivire: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	magby: {
		tier: "LC",
	},
	magmar: {
		tier: "NFE",
	},
	magmortar: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	pinsir: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pinsirmega: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	tauros: {
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "UUBL",
		doublesTier: "DUU",
	},
	gyaradosmega: {
		tier: "OU",
		doublesTier: "DUU",
	},
	lapras: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	ditto: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	eevee: {
		tier: "LC",
	},
	vaporeon: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	jolteon: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	flareon: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	espeon: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	umbreon: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	leafeon: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	glaceon: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	porygon: {
		tier: "NFE",
	},
	porygon2: {
		tier: "RU",
		doublesTier: "DOU",
	},
	porygonz: {
		tier: "UUBL",
		doublesTier: "DUU",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	aerodactyl: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	aerodactylmega: {
		tier: "UU",
		doublesTier: "DUU",
	},
	munchlax: {
		tier: "LC",
	},
	snorlax: {
		tier: "RU",
		doublesTier: "DUber",
	},
	articuno: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	zapdos: {
		tier: "OU",
		doublesTier: "DOU",
	},
	moltres: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NFE",
	},
	dragonite: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	mewtwo: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	mewtwomegax: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	mewtwomegay: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	mew: {
		tier: "UU",
		doublesTier: "DOU",
	},
	chikorita: {
		tier: "LC",
	},
	bayleef: {
		tier: "NFE",
	},
	meganium: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	cyndaquil: {
		tier: "LC",
	},
	quilava: {
		tier: "NFE",
	},
	typhlosion: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	totodile: {
		tier: "LC",
	},
	croconaw: {
		tier: "NFE",
	},
	feraligatr: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	sentret: {
		tier: "LC",
	},
	furret: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	hoothoot: {
		tier: "LC",
	},
	noctowl: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	ledyba: {
		tier: "LC",
	},
	ledian: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	spinarak: {
		tier: "LC",
	},
	ariados: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	chinchou: {
		tier: "LC",
	},
	lanturn: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	togepi: {
		tier: "LC",
	},
	togetic: {
		tier: "NFE",
	},
	togekiss: {
		tier: "UU",
		doublesTier: "DUU",
	},
	natu: {
		tier: "LC",
	},
	xatu: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	mareep: {
		tier: "LC",
	},
	flaaffy: {
		tier: "NFE",
	},
	ampharos: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	ampharosmega: {
		tier: "RU",
		doublesTier: "DUU",
	},
	azurill: {
		tier: "LC",
	},
	marill: {
		tier: "NFE",
	},
	azumarill: {
		tier: "OU",
		doublesTier: "DUU",
	},
	bonsly: {
		tier: "LC",
	},
	sudowoodo: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	hoppip: {
		tier: "LC",
	},
	skiploom: {
		tier: "NFE",
	},
	jumpluff: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	aipom: {
		tier: "NFE",
	},
	ambipom: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	sunkern: {
		tier: "LC",
	},
	sunflora: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	yanma: {
		tier: "NFE",
	},
	yanmega: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	wooper: {
		tier: "LC",
	},
	quagsire: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	murkrow: {
		tier: "NFE",
	},
	honchkrow: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	misdreavus: {
		tier: "NFE",
	},
	mismagius: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	unown: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	wynaut: {
		tier: "LC",
	},
	wobbuffet: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	girafarig: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pineco: {
		tier: "LC",
	},
	forretress: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	dunsparce: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	gligar: {
		tier: "UU",
		doublesTier: "NFE",
	},
	gliscor: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	snubbull: {
		tier: "LC",
	},
	granbull: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	qwilfish: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	shuckle: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	heracross: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	heracrossmega: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	sneasel: {
		tier: "NU",
		doublesTier: "NFE",
	},
	weavile: {
		tier: "UUBL",
		doublesTier: "DUU",
	},
	teddiursa: {
		tier: "LC",
	},
	ursaring: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	slugma: {
		tier: "LC",
	},
	magcargo: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		tier: "NU",
		doublesTier: "NFE",
	},
	mamoswine: {
		tier: "UU",
		doublesTier: "DUU",
	},
	corsola: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	remoraid: {
		tier: "LC",
	},
	octillery: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	delibird: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	mantyke: {
		tier: "LC",
	},
	mantine: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	skarmory: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	houndour: {
		tier: "LC",
	},
	houndoom: {
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	houndoommega: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	stantler: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	smeargle: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	miltank: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	raikou: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	entei: {
		tier: "RUBL",
		doublesTier: "DUU",
	},
	suicune: {
		tier: "UU",
		doublesTier: "DOU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NFE",
	},
	tyranitar: {
		tier: "OU",
		doublesTier: "DOU",
	},
	tyranitarmega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	lugia: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	hooh: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	celebi: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	treecko: {
		tier: "LC",
	},
	grovyle: {
		tier: "NFE",
	},
	sceptile: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	sceptilemega: {
		tier: "RU",
		doublesTier: "DUU",
	},
	torchic: {
		tier: "LC",
	},
	combusken: {
		tier: "NFE",
	},
	blaziken: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	blazikenmega: {
		tier: "Uber",
		doublesTier: "DUU",
	},
	mudkip: {
		tier: "LC",
	},
	marshtomp: {
		tier: "NFE",
	},
	swampert: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	swampertmega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	poochyena: {
		tier: "LC",
	},
	mightyena: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	zigzagoon: {
		tier: "LC",
	},
	linoone: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	wurmple: {
		tier: "LC",
	},
	silcoon: {
		tier: "NFE",
	},
	beautifly: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	cascoon: {
		tier: "NFE",
	},
	dustox: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	lotad: {
		tier: "LC",
	},
	lombre: {
		tier: "NFE",
	},
	ludicolo: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	seedot: {
		tier: "LC",
	},
	nuzleaf: {
		tier: "NFE",
	},
	shiftry: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	taillow: {
		tier: "LC",
	},
	swellow: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	wingull: {
		tier: "NFE",
	},
	pelipper: {
		tier: "OU",
		doublesTier: "DOU",
	},
	ralts: {
		tier: "LC",
	},
	kirlia: {
		tier: "NFE",
	},
	gardevoir: {
		tier: "RU",
		doublesTier: "DUU",
	},
	gardevoirmega: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	gallade: {
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	gallademega: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	surskit: {
		tier: "LC",
	},
	masquerain: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	shroomish: {
		tier: "LC",
	},
	breloom: {
		tier: "UUBL",
		doublesTier: "DUU",
	},
	slakoth: {
		tier: "LC",
	},
	vigoroth: {
		tier: "NFE",
	},
	slaking: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	nincada: {
		tier: "LC",
	},
	ninjask: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	shedinja: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	whismur: {
		tier: "LC",
	},
	loudred: {
		tier: "NFE",
	},
	exploud: {
		tier: "NUBL",
		doublesTier: "(DUU)",
	},
	makuhita: {
		tier: "LC",
	},
	hariyama: {
		tier: "NU",
		doublesTier: "DUU",
	},
	nosepass: {
		tier: "LC",
	},
	probopass: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	skitty: {
		tier: "LC",
	},
	delcatty: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	sableye: {
		tier: "PU",
		doublesTier: "DUU",
	},
	sableyemega: {
		tier: "OU",
		doublesTier: "DUU",
	},
	mawile: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	mawilemega: {
		tier: "OU",
		doublesTier: "DUU",
	},
	aron: {
		tier: "LC",
	},
	lairon: {
		tier: "NFE",
	},
	aggron: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	aggronmega: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	meditite: {
		tier: "NFE",
	},
	medicham: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	medichammega: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	electrike: {
		tier: "LC",
	},
	manectric: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	manectricmega: {
		tier: "UU",
		doublesTier: "DOU",
	},
	plusle: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	minun: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	volbeat: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	illumise: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	budew: {
		tier: "LC",
	},
	roselia: {
		tier: "PU",
		doublesTier: "NFE",
	},
	roserade: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	gulpin: {
		tier: "LC",
	},
	swalot: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	carvanha: {
		tier: "LC",
	},
	sharpedo: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	sharpedomega: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	wailmer: {
		tier: "LC",
	},
	wailord: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	numel: {
		tier: "LC",
	},
	camerupt: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	cameruptmega: {
		tier: "NUBL",
		doublesTier: "DOU",
	},
	torkoal: {
		tier: "(PU)",
		doublesTier: "DUU",
	},
	spoink: {
		tier: "LC",
	},
	grumpig: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	spinda: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	trapinch: {
		tier: "NFE",
	},
	vibrava: {
		tier: "NFE",
	},
	flygon: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	cacnea: {
		tier: "LC",
	},
	cacturne: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	swablu: {
		tier: "LC",
	},
	altaria: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	altariamega: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	zangoose: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	seviper: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	lunatone: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	solrock: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	barboach: {
		tier: "LC",
	},
	whiscash: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	corphish: {
		tier: "LC",
	},
	crawdaunt: {
		tier: "UU",
		doublesTier: "DUU",
	},
	baltoy: {
		tier: "LC",
	},
	claydol: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	lileep: {
		tier: "LC",
	},
	cradily: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	anorith: {
		tier: "LC",
	},
	armaldo: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	feebas: {
		tier: "LC",
	},
	milotic: {
		tier: "RU",
		doublesTier: "DOU",
	},
	castform: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	castformsunny: {
	},
	castformrainy: {
	},
	castformsnowy: {
	},
	kecleon: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	shuppet: {
		tier: "LC",
	},
	banette: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	banettemega: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	duskull: {
		tier: "LC",
	},
	dusclops: {
		tier: "NFE",
	},
	dusknoir: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	tropius: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	chingling: {
		tier: "LC",
	},
	chimecho: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	absol: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	absolmega: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	snorunt: {
		tier: "LC",
	},
	glalie: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	glaliemega: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	froslass: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	spheal: {
		tier: "LC",
	},
	sealeo: {
		tier: "NFE",
	},
	walrein: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	clamperl: {
		tier: "LC",
	},
	huntail: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	gorebyss: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	relicanth: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	luvdisc: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	bagon: {
		tier: "LC",
	},
	shelgon: {
		tier: "NFE",
	},
	salamence: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	salamencemega: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	beldum: {
		tier: "LC",
	},
	metang: {
		tier: "NFE",
	},
	metagross: {
		tier: "RU",
		doublesTier: "DUU",
	},
	metagrossmega: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	regirock: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	regice: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	registeel: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	latias: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	latiasmega: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	latios: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	latiosmega: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	kyogre: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	kyogreprimal: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	groudon: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	groudonprimal: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	rayquaza: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	rayquazamega: {
		tier: "AG",
		doublesTier: "DUber",
	},
	jirachi: {
		tier: "OU",
		doublesTier: "DUber",
	},
	deoxys: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	deoxysattack: {
		tier: "Uber",
		doublesTier: "DUU",
	},
	deoxysdefense: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	deoxysspeed: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	turtwig: {
		tier: "LC",
	},
	grotle: {
		tier: "NFE",
	},
	torterra: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	chimchar: {
		tier: "LC",
	},
	monferno: {
		tier: "NFE",
	},
	infernape: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	piplup: {
		tier: "LC",
	},
	prinplup: {
		tier: "NFE",
	},
	empoleon: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	starly: {
		tier: "LC",
	},
	staravia: {
		tier: "NFE",
	},
	staraptor: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	bidoof: {
		tier: "LC",
	},
	bibarel: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	kricketot: {
		tier: "LC",
	},
	kricketune: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	shinx: {
		tier: "LC",
	},
	luxio: {
		tier: "NFE",
	},
	luxray: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	cranidos: {
		tier: "LC",
	},
	rampardos: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	shieldon: {
		tier: "LC",
	},
	bastiodon: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	burmy: {
		tier: "LC",
	},
	wormadam: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	wormadamsandy: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	wormadamtrash: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	mothim: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	combee: {
		tier: "LC",
	},
	vespiquen: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pachirisu: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	buizel: {
		tier: "LC",
	},
	floatzel: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	cherubi: {
		tier: "LC",
	},
	cherrim: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	cherrimsunshine: {
	},
	shellos: {
		tier: "LC",
	},
	gastrodon: {
		tier: "PU",
		doublesTier: "DOU",
	},
	drifloon: {
		tier: "NFE",
	},
	drifblim: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	buneary: {
		tier: "LC",
	},
	lopunny: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	lopunnymega: {
		tier: "OU",
		doublesTier: "DUU",
	},
	glameow: {
		tier: "LC",
	},
	purugly: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	stunky: {
		tier: "LC",
	},
	skuntank: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	bronzor: {
		tier: "LC",
	},
	bronzong: {
		tier: "RU",
		doublesTier: "DUU",
	},
	chatot: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	spiritomb: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	gible: {
		tier: "LC",
	},
	gabite: {
		tier: "NFE",
	},
	garchomp: {
		tier: "OU",
		doublesTier: "DOU",
	},
	garchompmega: {
		tier: "(OU)",
		doublesTier: "(DOU)",
	},
	riolu: {
		tier: "LC",
	},
	lucario: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	lucariomega: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	hippopotas: {
		tier: "LC",
	},
	hippowdon: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	skorupi: {
		tier: "LC",
	},
	drapion: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	croagunk: {
		tier: "LC",
	},
	toxicroak: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	carnivine: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	finneon: {
		tier: "LC",
	},
	lumineon: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	snover: {
		tier: "LC",
	},
	abomasnow: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	abomasnowmega: {
		tier: "NU",
		doublesTier: "DUU",
	},
	rotom: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	rotomheat: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	rotomwash: {
		tier: "OU",
		doublesTier: "DUU",
	},
	rotomfrost: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	rotomfan: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	rotommow: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	uxie: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	mesprit: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	azelf: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	dialga: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	palkia: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	heatran: {
		tier: "OU",
		doublesTier: "DOU",
	},
	regigigas: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	giratina: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	giratinaorigin: {
	},
	cresselia: {
		tier: "RU",
		doublesTier: "DOU",
	},
	phione: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	manaphy: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	darkrai: {
		tier: "Uber",
		doublesTier: "DUU",
	},
	shaymin: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	shayminsky: {
		tier: "Uber",
		doublesTier: "DUU",
	},
	arceus: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	arceusbug: {
	},
	arceusdark: {
	},
	arceusdragon: {
	},
	arceuselectric: {
	},
	arceusfairy: {
	},
	arceusfighting: {
	},
	arceusfire: {
	},
	arceusflying: {
	},
	arceusghost: {
	},
	arceusgrass: {
	},
	arceusground: {
	},
	arceusice: {
	},
	arceuspoison: {
	},
	arceuspsychic: {
	},
	arceusrock: {
	},
	arceussteel: {
	},
	arceuswater: {
	},
	victini: {
		tier: "OU",
		doublesTier: "DOU",
	},
	snivy: {
		tier: "LC",
	},
	servine: {
		tier: "NFE",
	},
	serperior: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	tepig: {
		tier: "LC",
	},
	pignite: {
		tier: "NFE",
	},
	emboar: {
		tier: "NUBL",
		doublesTier: "(DUU)",
	},
	oshawott: {
		tier: "LC",
	},
	dewott: {
		tier: "NFE",
	},
	samurott: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	patrat: {
		tier: "LC",
	},
	watchog: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	lillipup: {
		tier: "LC",
	},
	herdier: {
		tier: "NFE",
	},
	stoutland: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	purrloin: {
		tier: "LC",
	},
	liepard: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	pansage: {
		tier: "LC",
	},
	simisage: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pansear: {
		tier: "LC",
	},
	simisear: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	panpour: {
		tier: "LC",
	},
	simipour: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	munna: {
		tier: "LC",
	},
	musharna: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	pidove: {
		tier: "LC",
	},
	tranquill: {
		tier: "NFE",
	},
	unfezant: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	blitzle: {
		tier: "LC",
	},
	zebstrika: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	roggenrola: {
		tier: "LC",
	},
	boldore: {
		tier: "NFE",
	},
	gigalith: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	woobat: {
		tier: "LC",
	},
	swoobat: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	drilbur: {
		tier: "LC",
	},
	excadrill: {
		tier: "OU",
		doublesTier: "DOU",
	},
	audino: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	audinomega: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	timburr: {
		tier: "LC",
	},
	gurdurr: {
		tier: "PU",
		doublesTier: "NFE",
	},
	conkeldurr: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	tympole: {
		tier: "LC",
	},
	palpitoad: {
		tier: "NFE",
	},
	seismitoad: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	throh: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	sawk: {
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	sewaddle: {
		tier: "LC",
	},
	swadloon: {
		tier: "NFE",
	},
	leavanny: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	venipede: {
		tier: "LC",
	},
	whirlipede: {
		tier: "NFE",
	},
	scolipede: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	cottonee: {
		tier: "LC",
	},
	whimsicott: {
		tier: "NU",
		doublesTier: "DOU",
	},
	petilil: {
		tier: "LC",
	},
	lilligant: {
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	basculin: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	basculinbluestriped: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	sandile: {
		tier: "LC",
	},
	krokorok: {
		tier: "NFE",
	},
	krookodile: {
		tier: "UU",
		doublesTier: "DUU",
	},
	darumaka: {
		tier: "LC",
	},
	darmanitan: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	maractus: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	dwebble: {
		tier: "LC",
	},
	crustle: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	scraggy: {
		tier: "LC",
	},
	scrafty: {
		tier: "NU",
		doublesTier: "DOU",
	},
	sigilyph: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	yamask: {
		tier: "LC",
	},
	cofagrigus: {
		tier: "NUBL",
		doublesTier: "DUU",
	},
	tirtouga: {
		tier: "LC",
	},
	carracosta: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	archen: {
		tier: "LC",
	},
	archeops: {
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	trubbish: {
		tier: "LC",
	},
	garbodor: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	zorua: {
		tier: "LC",
	},
	zoroark: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	minccino: {
		tier: "LC",
	},
	cinccino: {
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	gothita: {
		tier: "NFE",
	},
	gothorita: {
		tier: "NFE",
	},
	gothitelle: {
		tier: "(PU)",
		doublesTier: "DOU",
	},
	solosis: {
		tier: "LC",
	},
	duosion: {
		tier: "NFE",
	},
	reuniclus: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	ducklett: {
		tier: "LC",
	},
	swanna: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	vanillite: {
		tier: "LC",
	},
	vanillish: {
		tier: "NFE",
	},
	vanilluxe: {
		tier: "NUBL",
		doublesTier: "(DUU)",
	},
	deerling: {
		tier: "LC",
	},
	sawsbuck: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	emolga: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	karrablast: {
		tier: "LC",
	},
	escavalier: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	foongus: {
		tier: "LC",
	},
	amoonguss: {
		tier: "UU",
		doublesTier: "DOU",
	},
	frillish: {
		tier: "LC",
	},
	jellicent: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	alomomola: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	joltik: {
		tier: "LC",
	},
	galvantula: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	ferroseed: {
		tier: "PU",
		doublesTier: "LC",
	},
	ferrothorn: {
		tier: "OU",
		doublesTier: "DOU",
	},
	klink: {
		tier: "LC",
	},
	klang: {
		tier: "NFE",
	},
	klinklang: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	tynamo: {
		tier: "LC",
	},
	eelektrik: {
		tier: "NFE",
	},
	eelektross: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	elgyem: {
		tier: "LC",
	},
	beheeyem: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	litwick: {
		tier: "LC",
	},
	lampent: {
		tier: "NFE",
	},
	chandelure: {
		tier: "UU",
		doublesTier: "DUU",
	},
	axew: {
		tier: "LC",
	},
	fraxure: {
		tier: "NFE",
	},
	haxorus: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	cubchoo: {
		tier: "LC",
	},
	beartic: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	cryogonal: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	shelmet: {
		tier: "LC",
	},
	accelgor: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	stunfisk: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	mienfoo: {
		tier: "LC",
	},
	mienshao: {
		tier: "RUBL",
		doublesTier: "DUU",
	},
	druddigon: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	golett: {
		tier: "LC",
	},
	golurk: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	pawniard: {
		tier: "LC",
	},
	bisharp: {
		tier: "UU",
		doublesTier: "DUU",
	},
	bouffalant: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	rufflet: {
		tier: "LC",
	},
	braviary: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	vullaby: {
		tier: "LC",
	},
	mandibuzz: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	heatmor: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	durant: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	deino: {
		tier: "LC",
	},
	zweilous: {
		tier: "NFE",
	},
	hydreigon: {
		tier: "UU",
		doublesTier: "DUU",
	},
	larvesta: {
		tier: "LC",
	},
	volcarona: {
		tier: "OU",
		doublesTier: "DOU",
	},
	cobalion: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	terrakion: {
		tier: "UU",
		doublesTier: "DOU",
	},
	virizion: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	tornadus: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	tornadustherian: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	thundurus: {
		tier: "UUBL",
		doublesTier: "DUU",
	},
	thundurustherian: {
		tier: "UUBL",
		doublesTier: "DUU",
	},
	reshiram: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	zekrom: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	landorus: {
		tier: "Uber",
		doublesTier: "DUU",
	},
	landorustherian: {
		tier: "OU",
		doublesTier: "DOU",
	},
	kyurem: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	kyuremblack: {
		tier: "OU",
		doublesTier: "DOU",
	},
	kyuremwhite: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	keldeo: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	keldeoresolute: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	meloetta: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	meloettapirouette: {
	},
	genesect: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	genesectburn: {
		tier: "Uber",
		doublesTier: "(DOU)",
	},
	genesectchill: {
		tier: "Uber",
		doublesTier: "(DOU)",
	},
	genesectdouse: {
		tier: "Uber",
		doublesTier: "(DOU)",
	},
	genesectshock: {
		tier: "Uber",
		doublesTier: "(DOU)",
	},
	chespin: {
		tier: "LC",
	},
	quilladin: {
		tier: "NFE",
	},
	chesnaught: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	fennekin: {
		tier: "LC",
	},
	braixen: {
		tier: "NFE",
	},
	delphox: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	froakie: {
		tier: "LC",
	},
	frogadier: {
		tier: "NFE",
	},
	greninja: {
		tier: "OU",
		doublesTier: "DUU",
	},
	greninjaash: {
		tier: "OU",
		doublesTier: "DUU",
	},
	bunnelby: {
		tier: "LC",
	},
	diggersby: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	fletchling: {
		tier: "LC",
	},
	fletchinder: {
		tier: "NFE",
	},
	talonflame: {
		tier: "RUBL",
		doublesTier: "DUU",
	},
	scatterbug: {
		tier: "LC",
	},
	spewpa: {
		tier: "NFE",
	},
	vivillon: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	vivillonfancy: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	vivillonpokeball: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	litleo: {
		tier: "LC",
	},
	pyroar: {
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	flabebe: {
		tier: "LC",
	},
	floette: {
		tier: "NFE",
	},
	floetteeternal: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	florges: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	skiddo: {
		tier: "LC",
	},
	gogoat: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pancham: {
		tier: "LC",
	},
	pangoro: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	furfrou: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	espurr: {
		tier: "LC",
	},
	meowstic: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	meowsticf: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	honedge: {
		tier: "LC",
	},
	doublade: {
		tier: "UU",
		doublesTier: "NFE",
	},
	aegislash: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	aegislashblade: {
	},
	spritzee: {
		tier: "LC",
	},
	aromatisse: {
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	swirlix: {
		tier: "NFE",
	},
	slurpuff: {
		tier: "NUBL",
		doublesTier: "(DUU)",
	},
	inkay: {
		tier: "LC",
	},
	malamar: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	binacle: {
		tier: "LC",
	},
	barbaracle: {
		tier: "NUBL",
		doublesTier: "(DUU)",
	},
	skrelp: {
		tier: "LC",
	},
	dragalge: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	clauncher: {
		tier: "LC",
	},
	clawitzer: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	helioptile: {
		tier: "LC",
	},
	heliolisk: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	tyrunt: {
		tier: "LC",
	},
	tyrantrum: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	amaura: {
		tier: "LC",
	},
	aurorus: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	sylveon: {
		tier: "UU",
		doublesTier: "DUU",
	},
	hawlucha: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	dedenne: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	carbink: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	goomy: {
		tier: "LC",
	},
	sliggoo: {
		tier: "NFE",
	},
	goodra: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	klefki: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	phantump: {
		tier: "LC",
	},
	trevenant: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pumpkaboo: {
		tier: "LC",
	},
	pumpkaboosmall: {
		tier: "LC",
	},
	pumpkaboolarge: {
		tier: "LC",
	},
	pumpkaboosuper: {
		tier: "LC",
	},
	gourgeist: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	gourgeistsmall: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	gourgeistlarge: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	gourgeistsuper: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	bergmite: {
		tier: "LC",
	},
	avalugg: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	noibat: {
		tier: "LC",
	},
	noivern: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	xerneas: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	yveltal: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	zygarde: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	zygarde10: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	zygardecomplete: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	diancie: {
		tier: "RU",
		doublesTier: "DOU",
	},
	dianciemega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	hoopa: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	hoopaunbound: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	volcanion: {
		tier: "UU",
		doublesTier: "DOU",
	},
	rowlet: {
		tier: "LC",
	},
	dartrix: {
		tier: "NFE",
	},
	decidueye: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	litten: {
		tier: "LC",
	},
	torracat: {
		tier: "NFE",
	},
	incineroar: {
		tier: "NU",
		doublesTier: "DOU",
	},
	popplio: {
		tier: "LC",
	},
	brionne: {
		tier: "NFE",
	},
	primarina: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	pikipek: {
		tier: "LC",
	},
	trumbeak: {
		tier: "NFE",
	},
	toucannon: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	yungoos: {
		tier: "LC",
	},
	gumshoos: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	gumshoostotem: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	grubbin: {
		tier: "LC",
	},
	charjabug: {
		tier: "NFE",
	},
	vikavolt: {
		tier: "NU",
		doublesTier: "DUU",
	},
	vikavolttotem: {
		tier: "NU",
		doublesTier: "DUU",
	},
	crabrawler: {
		tier: "LC",
	},
	crabominable: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	oricorio: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	oricoriopompom: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	oricoriopau: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	oricoriosensu: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	cutiefly: {
		tier: "NFE",
	},
	ribombee: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	ribombeetotem: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	rockruff: {
		tier: "LC",
	},
	rockruffdusk: {
		tier: "LC",
	},
	lycanroc: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	lycanrocmidnight: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	lycanrocdusk: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	wishiwashi: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	wishiwashischool: {
	},
	mareanie: {
		tier: "LC",
	},
	toxapex: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	mudbray: {
		tier: "LC",
	},
	mudsdale: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	dewpider: {
		tier: "LC",
	},
	araquanid: {
		tier: "RU",
		doublesTier: "DUU",
	},
	araquanidtotem: {
		tier: "RU",
		doublesTier: "DUU",
	},
	fomantis: {
		tier: "LC",
	},
	lurantis: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	lurantistotem: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	morelull: {
		tier: "LC",
	},
	shiinotic: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	salandit: {
		tier: "LC",
	},
	salazzle: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	salazzletotem: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	stufful: {
		tier: "LC",
	},
	bewear: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	bounsweet: {
		tier: "LC",
	},
	steenee: {
		tier: "NFE",
	},
	tsareena: {
		tier: "RU",
		doublesTier: "DUU",
	},
	comfey: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	oranguru: {
		tier: "(PU)",
		doublesTier: "DUU",
	},
	passimian: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	wimpod: {
		tier: "LC",
	},
	golisopod: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	sandygast: {
		tier: "LC",
	},
	palossand: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	pyukumuku: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	typenull: {
		tier: "(PU)",
		doublesTier: "NFE",
	},
	silvally: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallybug: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallydark: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallydragon: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallyelectric: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallyfairy: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	silvallyfighting: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallyfire: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallyflying: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallyghost: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	silvallygrass: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallyground: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallyice: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallypoison: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallypsychic: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallyrock: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallysteel: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	silvallywater: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	minior: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	miniormeteor: {},
	komala: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	turtonator: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	togedemaru: {
		tier: "NU",
		doublesTier: "DUU",
	},
	togedemarutotem: {
		tier: "NU",
		doublesTier: "DUU",
	},
	mimikyu: {
		tier: "UU",
		doublesTier: "DUU",
	},
	mimikyutotem: {
		tier: "UU",
		doublesTier: "DUU",
	},
	mimikyubustedtotem: {},
	bruxish: {
		tier: "NUBL",
		doublesTier: "DUU",
	},
	drampa: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	dhelmise: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	jangmoo: {
		tier: "LC",
	},
	hakamoo: {
		tier: "NFE",
	},
	kommoo: {
		tier: "OU",
		doublesTier: "DOU",
	},
	kommoototem: {
		tier: "OU",
		doublesTier: "DOU",
	},
	tapukoko: {
		tier: "OU",
		doublesTier: "DOU",
	},
	tapulele: {
		tier: "OU",
		doublesTier: "DOU",
	},
	tapubulu: {
		tier: "OU",
		doublesTier: "DOU",
	},
	tapufini: {
		tier: "OU",
		doublesTier: "DOU",
	},
	cosmog: {
		tier: "LC",
	},
	cosmoem: {
		tier: "NFE",
	},
	solgaleo: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	lunala: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	nihilego: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	buzzwole: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	pheromosa: {
		tier: "Uber",
		doublesTier: "DUU",
	},
	xurkitree: {
		tier: "UUBL",
		doublesTier: "DUU",
	},
	celesteela: {
		tier: "OU",
		doublesTier: "DOU",
	},
	kartana: {
		tier: "OU",
		doublesTier: "DOU",
	},
	guzzlord: {
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	necrozma: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	necrozmaduskmane: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	necrozmadawnwings: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	necrozmaultra: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	magearna: {
		tier: "OU",
		doublesTier: "DUber",
	},
	magearnaoriginal: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	marshadow: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	poipole: {
		tier: "NFE",
	},
	naganadel: {
		tier: "Uber",
		doublesTier: "DUU",
	},
	stakataka: {
		tier: "RUBL",
		doublesTier: "DOU",
	},
	blacephalon: {
		tier: "OU",
		doublesTier: "DUU",
	},
	zeraora: {
		tier: "UU",
		doublesTier: "DOU",
	},
	meltan: {
		isNonstandard: "LGPE",
		tier: "Illegal",
	},
	melmetal: {
		isNonstandard: "LGPE",
		tier: "Illegal",
	},
};
